var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@uigovpe/components";
import { Link as RouterLink } from "react-router-dom";
import { capitalizeSentence, formatDateTime, truncateText, } from "../../consultations/utils/formatters";
import { getHearingStatusDisplay, hearingTypeLabels, hearingStatusStyles, isHearingLive, } from "../utils/status";
var linkStyle = {
    borderRadius: 8,
    color: "inherit",
    display: "block",
    height: "100%",
    textDecoration: "none",
};
var cardStyle = {
    border: "1px solid #E5E7EB",
    borderRadius: 8,
    boxShadow: "0 8px 20px rgba(15, 23, 42, 0.10)",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    minHeight: 270,
    padding: 16,
};
var cardContentStyle = {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    gap: 8,
    paddingTop: 16,
};
var metaRowStyle = {
    alignItems: "center",
    display: "flex",
    gap: 8,
    justifyContent: "space-between",
};
var ribbonStyle = {
    background: "#1451B4",
    borderBottomLeftRadius: 6,
    borderBottomRightRadius: 6,
    color: "#FFFFFF",
    display: "inline-flex",
    marginTop: -16,
    maxWidth: "max-content",
    padding: "4px 8px",
};
var liveStatusStyle = {
    background: "#EAFBD7",
    color: "#245C15",
};
export var HomeHearingCard = function (_a) {
    var _b, _c, _d;
    var hearing = _a.hearing;
    var statusDisplay = getHearingStatusDisplay(hearing);
    var statusStyle = isHearingLive(hearing)
        ? liveStatusStyle
        : hearingStatusStyles[hearing.status];
    return (_jsx(RouterLink, __assign({ style: linkStyle, to: "/hearings/details/".concat(hearing.id) }, { children: _jsxs("div", __assign({ style: cardStyle }, { children: [_jsx("div", __assign({ style: ribbonStyle }, { children: _jsx(Typography, __assign({ fontWeight: "bold", size: "xs", style: { color: "#FFFFFF" } }, { children: ((_b = hearing.agency) === null || _b === void 0 ? void 0 : _b.acronym) || ((_c = hearing.agency) === null || _c === void 0 ? void 0 : _c.name) || "PE" })) })), _jsxs("div", __assign({ style: cardContentStyle }, { children: [_jsx(Typography, __assign({ fontWeight: "bold", size: "sm" }, { children: capitalizeSentence(hearing.title) })), _jsx(Typography, __assign({ size: "sm" }, { children: truncateText(capitalizeSentence(hearing.description), 180) })), _jsxs("div", __assign({ style: { marginTop: "auto", paddingTop: 8 } }, { children: [_jsxs(Typography, __assign({ size: "sm" }, { children: [_jsx("strong", { children: "Tema: " }), truncateText(((_d = hearing.theme) === null || _d === void 0 ? void 0 : _d.name) || "-", 30)] })), _jsxs(Typography, __assign({ size: "sm" }, { children: [_jsx("strong", { children: "Tipo: " }), hearingTypeLabels[hearing.type]] })), _jsxs("div", __assign({ style: metaRowStyle }, { children: [_jsx(Typography, __assign({ size: "sm" }, { children: formatDateTime(hearing.startDate) })), _jsx("div", __assign({ style: __assign(__assign({}, statusStyle), { borderRadius: 999, fontSize: 12, fontWeight: 700, padding: "4px 12px" }) }, { children: statusDisplay.label }))] }))] }))] }))] })) })));
};
